import { render, staticRenderFns } from "./SmsUsageListDetail.vue?vue&type=template&id=412f284c&"
import script from "./SmsUsageListDetail.vue?vue&type=script&lang=ts&"
export * from "./SmsUsageListDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports